import React from "react"

export const BackgrounLogo = () =>
    <svg style={{
        position: "fixed",
        zIndex: -1,
        opacity: 0.08,
        right: "-21%",
        bottom: "-10%",
    }} width="60%" height="60%" viewBox="0 0 500 500" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.209 461.213H385.629L430.618 573.621H554.339L469.18 353.693H230.586L190.209 461.213Z" fillRule="evenodd" clipRule="evenodd" className="fill-secondary"></path>
        <path d="M288.881 198.459L339.033 332.515H461.146L346.828 44.1536L288.881 198.459Z" fillRule="evenodd" clipRule="evenodd" className="fill-secondary"></path>
        <path d="M334.791 13.7914L334.212 12.3323H220.132L0.00634766 573.621H123.727L277.172 167.161L277.184 167.192L334.791 13.7914Z" fillRule="evenodd" clipRule="evenodd" className="fill-secondary"></path>
    </svg>
